import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestSettingsPatch = {
    path: "/settings",
    method: RouteHttpVerb.PATCH
};
export { locationRestSettingsPatch };
